import DOMPurify from 'dompurify';

/**
 * Очищує HTML від inline стилів, класів та небезпечних атрибутів.
 * Залишає тільки базові теги для форматування тексту.
 *
 * @param {string} html - HTML рядок для очистки
 * @returns {string} - Очищений HTML
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';

  // Налаштування DOMPurify
  const config = {
    // Дозволені теги
    ALLOWED_TAGS: [
      'p', 'br', 'div',
      'ul', 'ol', 'li',
      'strong', 'b', 'em', 'i', 'u',
      'span', 'h3', 'h4', 'h5',
      'table', 'tr', 'td', 'th', 'tbody', 'thead',
    ],
    // Забороняємо всі атрибути (видаляє style, class, data-*, тощо)
    ALLOWED_ATTR: [],
    // Видаляємо порожні елементи
    KEEP_CONTENT: true,
  };

  return DOMPurify.sanitize(html, config);
};

export default sanitizeHtml;
